<template>
  <div class="d-flex h-100">
    <div class="d-flex flex-column flex-grow-1">
      <div>
        <div class="sidebar-header container-fluid">
          <h2 class="font-bold mb-0">
            <font-awesome-icon :icon="['fad', 'book-medical']" class="mr-5" />
            {{ $t('admin.medicalReportLibrary.list.title') }}
          </h2>
        </div>
        <div class="pt-6">
          <div class="container-fluid mb-6">
            <router-link
              :to="{
                name: 'newMedicalReportLibraryItem',
                params: { topicName: topic.name },
              }"
              class="btn btn-primary btn-block"
              v-if="topic"
            >
              {{ $t('admin.medicalReportLibrary.list.newButton') }}
            </router-link>

            <p class="text-center">
              <router-link :to="{ name: 'admin' }" class="btn btn-link">
                <font-awesome-icon
                  :icon="['fal', 'long-arrow-left']"
                  class="icon-md"
                />
                {{ $t('admin.medicalReportLibrary.list.backButton') }}
              </router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="flex-grow-2 overflow-auto">
        <div class="pb-6">
          <div class="list-group list-group-root">
            <library-topic
              v-for="localTopic in topics"
              :key="localTopic.name"
              :topic="localTopic"
              :active="topic && localTopic.name === topic.name"
              :libraryItemId="libraryItemId"
              @select="setTopic"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MedicalReportLibraryMixin from '@/mixins/medical-report-library';
import LibraryTopic from './tree/topic';

export default {
  name: 'MedicalReportingLibrarySidebar',
  mixins: [MedicalReportLibraryMixin],
  components: { LibraryTopic },
  props: ['libraryItemId'],
  computed: {
    topics() {
      return this.services.medicalReportLibrary.findAllTopics(true);
    },
  },
  methods: {
    setTopic(topic) {
      this.topic = topic;
    },
  },
};
</script>
